module.exports = __webpack_public_path__ + "img/suggestion_icon_heart.ab498a52.svg";